import i18next from 'i18next';

import type { FC } from 'react';
import React, { useState } from 'react';

import { resources } from '@/localization/i18n';

import Select from '../inputs/select/Select';

import styles from './styles.module.scss';

interface LangSwitcherProps {
  openUp?: boolean,
}

const LangSwitcher: FC<LangSwitcherProps> = ({ openUp = false }) => {
  const isExportMode = process.env.MARKET === 'export';

  const defaultLang = localStorage.getItem('i18nextLng') || (isExportMode ? 'en' : 'ru');
  const [lng, setLng] = useState(Object.keys(resources)
    .includes(defaultLang)
    ? defaultLang
    : Object.keys(resources)[0]);

  const handleLngChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLng = e.currentTarget.value;
    setLng(newLng);
    i18next.changeLanguage(newLng);
  };

  return (
    <div className={styles.switcher}>
      <Select
        name="lng"
        list={Object.keys(resources)}
        value={lng}
        onChange={handleLngChange}
        openUp={openUp}
        required
        fullWidth
      />
    </div>
  );
};

export default LangSwitcher;
